import { useState } from "react";

import {
  PDFDocument,
} from "pdf-lib";

import { saveAs }
from "file-saver";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function SplitPdf() {

  const [file, setFile] =
    useState(null);

  const [pageRange,
    setPageRange] =
    useState("");

  const [loading,
    setLoading] =
    useState(false);

  const [success,
    setSuccess] =
    useState("");

  /* HANDLE FILE */

  const handleFileChange =
    (e) => {

      const selected =
        e.target.files[0];

      if (
        selected &&
        selected.type ===
          "application/pdf"
      ) {

        setFile(selected);

      } else {

        alert(
          "Please upload a valid PDF file"
        );
      }
    };

  /* FORMAT SIZE */

  const formatSize =
    (bytes) => {

      return (
        (bytes / 1024 / 1024)
          .toFixed(2) + " MB"
      );
    };

  /* SPLIT PDF */

  const splitPDF =
    async () => {

      if (!file) {

        alert(
          "Please upload a PDF file"
        );

        return;
      }

      if (!pageRange) {

        alert(
          "Please enter page range"
        );

        return;
      }

      try {

        setLoading(true);

        const bytes =
          await file.arrayBuffer();

        const pdf =
          await PDFDocument.load(
            bytes
          );

        const pages =
          pageRange
            .split(",")
            .map(
              (p) =>
                parseInt(
                  p.trim()
                ) - 1
            );

        const newPdf =
          await PDFDocument.create();

        const copiedPages =
          await newPdf.copyPages(
            pdf,
            pages
          );

        copiedPages.forEach(
          (page) => {

            newPdf.addPage(page);
          }
        );

        const pdfBytes =
          await newPdf.save();

        const blob =
          new Blob(
            [pdfBytes],
            {
              type:
                "application/pdf",
            }
          );

        saveAs(
          blob,
          "split-pdf.pdf"
        );

        setSuccess(
          "PDF split successfully!"
        );

      } catch (error) {

        console.error(error);

        alert(
          "Error splitting PDF"
        );

      } finally {

        setLoading(false);
      }
    };

  /* SPLIT ALL PAGES */

  const splitAllPages =
    async () => {

      if (!file) {

        alert(
          "Please upload PDF"
        );

        return;
      }

      try {

        setLoading(true);

        const bytes =
          await file.arrayBuffer();

        const pdf =
          await PDFDocument.load(
            bytes
          );

        const totalPages =
          pdf.getPageCount();

        for (
          let i = 0;
          i < totalPages;
          i++
        ) {

          const newPdf =
            await PDFDocument.create();

          const [page] =
            await newPdf.copyPages(
              pdf,
              [i]
            );

          newPdf.addPage(page);

          const pdfBytes =
            await newPdf.save();

          const blob =
            new Blob(
              [pdfBytes],
              {
                type:
                  "application/pdf",
              }
            );

          saveAs(
            blob,
            `page-${i + 1}.pdf`
          );
        }

        setSuccess(
          "All pages downloaded separately!"
        );

      } catch (error) {

        console.error(error);

        alert(
          "Error splitting PDF"
        );

      } finally {

        setLoading(false);
      }
    };

  return (
    <>
      <SEO
        title="Split PDF Online Free"
        description="Split PDF pages instantly online for free. Extract pages securely in your browser."
        keywords="split pdf, extract pdf pages, pdf splitter online, free pdf split"
        url="https://online-tools-center.vercel.app/split-pdf"
      />

      <Navbar />

      <div className="container py-4">

        <div className="row justify-content-center">

          <div className="col-lg-10">

            <div className="card shadow-lg border-0 rounded-4 p-4">

              {/* HERO */}

              <div className="text-center mb-5">

                <h1 className="fw-bold mb-3">
                  Split PDF Files
                </h1>

                <p className="text-muted">
                  Extract pages from PDFs
                  instantly and securely
                  using your browser.
                </p>

                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">

                  <span className="badge bg-light text-dark p-2">
                    ✓ Extract PDF Pages
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Browser Based
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Fast Processing
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Free Tool
                  </span>

                </div>

              </div>

              {/* FILE INPUT */}

              <div className="mb-4">

                <label className="fw-semibold mb-2">
                  Upload PDF File
                </label>

                <input
                  type="file"
                  accept=".pdf"
                  className="form-control"
                  onChange={
                    handleFileChange
                  }
                />

              </div>

              {/* FILE INFO */}

              {file && (

                <div className="card border-0 bg-light rounded-4 p-3 mb-4">

                  <h5 className="fw-bold">
                    Uploaded File
                  </h5>

                  <p className="mb-1">
                    <strong>
                      Name:
                    </strong>
                    {" "}
                    {file.name}
                  </p>

                  <p className="mb-0">
                    <strong>
                      Size:
                    </strong>
                    {" "}
                    {formatSize(
                      file.size
                    )}
                  </p>

                </div>

              )}

              {/* PAGE RANGE */}

              <div className="mb-4">

                <label className="fw-semibold mb-2">
                  Enter Pages
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Example: 1,2,5"
                  value={pageRange}
                  onChange={(e) =>
                    setPageRange(
                      e.target.value
                    )
                  }
                />

                <small className="text-muted">
                  Separate pages using commas
                </small>

              </div>

              {/* ACTIONS */}

              <div className="d-flex flex-wrap gap-3">

                <button
                  className="btn btn-primary"
                  onClick={splitPDF}
                  disabled={loading}
                >

                  {loading
                    ? "Processing..."
                    : "Split Selected Pages"}

                </button>

                <button
                  className="btn btn-dark"
                  onClick={splitAllPages}
                  disabled={loading}
                >
                  Split All Pages
                </button>

              </div>

              {/* SUCCESS */}

              {success && (

                <div className="alert alert-success mt-4">

                  {success}

                </div>

              )}

            </div>

            {/* SEO CONTENT */}

            <div className="mt-5">

              <h2 className="fw-bold mb-3">
                What is a PDF Splitter?
              </h2>

              <p>
                A PDF splitter helps users
                extract pages from PDF files
                quickly and securely without
                uploading files to external
                servers.
              </p>

              <h2 className="fw-bold mt-5 mb-3">
                Features of Our PDF Split Tool
              </h2>

              <ul>

                <li>
                  Split selected pages
                </li>

                <li>
                  Download pages separately
                </li>

                <li>
                  Browser-based secure processing
                </li>

                <li>
                  Fast extraction
                </li>

                <li>
                  Mobile responsive
                </li>

                <li>
                  Free online PDF tool
                </li>

              </ul>

              <h2 className="fw-bold mt-5 mb-3">
                How to Split PDF?
              </h2>

              <ol>

                <li>
                  Upload PDF file
                </li>

                <li>
                  Enter pages to extract
                </li>

                <li>
                  Click split button
                </li>

                <li>
                  Download split PDF
                </li>

              </ol>

              <h2 className="fw-bold mt-5 mb-3">
                Frequently Asked Questions
              </h2>

              <div className="mb-4">

                <h5>
                  Is this PDF splitter free?
                </h5>

                <p>
                  Yes, this PDF splitting
                  tool is completely free.
                </p>

              </div>

              <div className="mb-4">

                <h5>
                  Are my PDF files secure?
                </h5>

                <p>
                  Yes, all processing happens
                  locally in your browser.
                </p>

              </div>

              <div className="mb-4">

                <h5>
                  Can I split all pages?
                </h5>

                <p>
                  Yes, you can download each
                  PDF page separately.
                </p>

              </div>

              {/* RELATED TOOLS */}

              <div className="mt-5 p-4 bg-light rounded-4">

                <h3 className="fw-bold mb-3">
                  Related PDF Tools
                </h3>

                <div className="d-flex flex-wrap gap-3">

                  <a
                    href="/merge-pdf"
                    className="btn btn-outline-primary"
                  >
                    Merge PDF
                  </a>

                  <a
                    href="/image-to-pdf"
                    className="btn btn-outline-primary"
                  >
                    Image to PDF
                  </a>

                  <a
                    href="/qr-generator"
                    className="btn btn-outline-primary"
                  >
                    QR Generator
                  </a>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}